module.exports = __webpack_public_path__ + "media/images/shared/suppliers/TANGDE-a4267854ea8233f3fc493fa650173eb0.jpg";